
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { getDeploymentInfo } from "@/utils/routingUtils";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Get deployment information for debugging
    const deploymentInfo = getDeploymentInfo();
    
    console.log("404 page rendered for path:", location.pathname);
    console.log("Full URL:", window.location.href);
    console.log("Deployment info:", deploymentInfo);
    console.log("Hostname:", window.location.hostname);
    
    // If we're on a path that looks like it might be a login redirect
    if (location.pathname.includes('callback') || location.search.includes('code=')) {
      console.log("Detected possible auth callback, redirecting to login");
      navigate('/login', { replace: true });
      return;
    }
    
    // Handle admin routes specifically
    if (location.pathname === '/admin' || location.pathname.startsWith('/admin/')) {
      console.log("Detected admin route in 404 page:", location.pathname);
      console.log("Host:", window.location.hostname);
      
      // Add a toast message to inform the user
      toast.info("Navigating to admin panel");
      
      // In case of www subdomain, first redirect to non-www
      if (window.location.hostname === 'www.truehr.co') {
        const newUrl = window.location.href.replace('www.truehr.co', 'truehr.co');
        console.log("Redirecting from www to non-www for admin:", newUrl);
        window.location.href = newUrl;
        return;
      }
      
      // Give our app a moment to handle the route properly
      setTimeout(() => {
        navigate('/admin', { replace: true });
      }, 100);
    }
  }, [location, navigate]);

  const handleReturnHome = () => {
    // Use React Router for navigation
    navigate('/', { replace: true });
  };

  const handleGoBack = () => {
    // Go back in history
    navigate(-1);
  };

  const handleGoToAdmin = () => {
    // Navigate to admin panel
    navigate('/admin', { replace: true });
  };

  const deploymentInfo = getDeploymentInfo();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
      <div className="text-center max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <h1 className="text-5xl font-bold text-gray-800 mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-6">Page not found</p>
        <p className="text-sm text-gray-500 mb-8">
          The page you are looking for might have been removed or is temporarily unavailable.
        </p>
        <div className="text-gray-500 text-xs mb-6 p-2 bg-gray-100 rounded">
          <p>Path: {location.pathname}</p>
          <p>Host: {window.location.hostname}</p>
          <p>Environment: {deploymentInfo.environment}</p>
        </div>
        <div className="space-y-4">
          <Button onClick={handleGoBack} variant="outline" className="w-full mb-2">
            Go Back
          </Button>
          {location.pathname.includes('admin') && (
            <Button onClick={handleGoToAdmin} variant="default" className="w-full mb-2">
              Go To Admin Panel
            </Button>
          )}
          <Button onClick={handleReturnHome} className="w-full">
            Return to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
